<div class="d-block w-100">
    <ul class="list-unstyled" id="searchFields">
        <li>
            <div class="tab w-100">
                <a #dateCreated
                   (click)="getTabContent($event)"
                   [ngClass]="{'active':activeTab == dateCreated.id}"
                   id="dateCreatedFilter">
                    Date&nbsp;Created <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #accountNumber
                   (click)="getTabContent($event)"
                   [ngClass]="{'active':activeTab == accountNumber.id}"
                   id="accountNumberFilter">
                    Account Number <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #reference
                   (click)="getTabContent($event)"
                   [ngClass]="{'active':activeTab == reference.id}"
                   id="referenceNumberFilter">
                    Reference <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #name (click)="getTabContent($event)" [ngClass]="{'active':activeTab == name.id}" id="nameFilter">
                    Name <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #amount
                   (click)="getTabContent($event)"
                   [ngClass]="{'active':activeTab == amount.id}"
                   id="amountFilter">
                    Amount <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #datePaid
                   (click)="getTabContent($event)"
                   [ngClass]="{'active':activeTab == datePaid.id}"
                   id="datePaidFilter">
                    Date&nbsp;Paid <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #accountStatus
                   (click)="getTabContent($event)"
                   [ngClass]="{'active':activeTab == accountStatus.id}"
                   id="accountStatusFilter">
                    Status <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #ecommerceStore
                   (click)="getTabContent($event)"
                   [hidden]="!showEcommerceStoreFilter"
                   [ngClass]="{'active':activeTab == ecommerceStore.id}"
                   id="ecommerceStoreFilter">
                    Shop <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #batch
                   (click)="getTabContent($event)"
                   [hidden]="!showBatchFilter"
                   [ngClass]="{'active':activeTab == batch.id}"
                   id="batchFilter">
                    Batch <em class="dropdown-toggle" style="float: right"></em>
                </a>
                <a #csvExport
                   (click)="getTabContent($event)"
                   [hidden]="!showCsvExport"
                   [ngClass]="{'active':activeTab == csvExport.id}"
                   id="csvExportFilter">
                    Download CSV <em class="dropdown-toggle" style="float: right"></em>
                </a>
            </div>
            <form [formGroup]="form">
                <div>
                    @switch (activeTab) {
                        @case (dateCreated.id) {
                            <div class="tabcontent">
                                <div class="date-input-group">
                                    <label class="date-label" for="dateTimeCreatedLower">From:</label>
                                    <input (change)="setSearchCriteria($event)"
                                           class="form-control d-inline"
                                           formControlName="dateTimeCreatedLower"
                                           id="dateTimeCreatedLower"
                                           max="{{dateCreatedUpper}}"
                                           placeholder=""
                                           type="date"
                                           value="{{dateCreatedLower}}"/>
                                </div>
                                <div class="date-input-group">
                                    <label class="date-label" for="dateTimeCreatedUpper">To:</label>
                                    <input (change)="setSearchCriteria($event)"
                                           class="form-control d-inline"
                                           formControlName="dateTimeCreatedUpper"
                                           id="dateTimeCreatedUpper"
                                           min="{{dateCreatedLower}}"
                                           placeholder=""
                                           type="date"
                                           value="{{dateCreatedUpper}}"/>
                                </div>
                            </div>
                        }
                        @case (accountNumber.id) {
                            <div class="tabcontent">
                                <input (input)="setSearchCriteria($event)"
                                       class="form-control"
                                       formControlName="accountNumber"
                                       id="accountNumber"
                                       placeholder="Account Number"
                                       type="text"
                                       value="{{accountNumber}}"/>
                            </div>
                        }
                        @case (reference.id) {
                            <div class="tabcontent">
                                <input (input)="setSearchCriteria($event)"
                                       class="form-control"
                                       formControlName="referenceNumber"
                                       id="referenceNumber"
                                       placeholder="Reference Number"
                                       type="text"
                                       value="{{referenceNumber}}"/>
                            </div>
                        }
                        @case (name.id) {
                            <div class="tabcontent">
                                <input (input)="setSearchCriteria($event)"
                                       class="form-control"
                                       formControlName="customer"
                                       id="customer"
                                       placeholder="Customer Name"
                                       type="text"
                                       value="{{customer}}"/>
                            </div>
                        }
                        @case (amount.id) {
                            <div class="tabcontent">
                                <input (change)="setSearchCriteria($event)"
                                       class="form-control"
                                       formControlName="amountLower"
                                       id="amountLower"
                                       max="{{amountUpper}}"
                                       min="0"
                                       placeholder="Lower Limit"
                                       type="number"/> <input (change)="setSearchCriteria($event)"
                                                              class="form-control"
                                                              formControlName="amountUpper"
                                                              id="amountUpper"
                                                              min="{{amountLower}}"
                                                              placeholder="Upper Limit"
                                                              type="number"/>
                            </div>
                        }
                        @case (datePaid.id) {
                            <div class="tabcontent">
                                <div class="date-input-group">
                                    <label class="date-label" for="dateTimePaidLower">From:</label>
                                    <input (change)="setSearchCriteria($event)"
                                           class="form-control d-inline"
                                           formControlName="dateTimePaidLower"
                                           id="dateTimePaidLower"
                                           max="{{datePaidUpper}}"
                                           placeholder=""
                                           type="date"
                                           value="{{datePaidLower}}"/>
                                </div>
                                <div class="date-input-group">
                                    <label class="date-label" for="dateTimePaidUpper">To:</label>
                                    <input (change)="setSearchCriteria($event)"
                                           class="form-control d-inline"
                                           formControlName="dateTimePaidUpper"
                                           id="dateTimePaidUpper"
                                           min="{{datePaidLower}}"
                                           placeholder=""
                                           type="date"
                                           value="{{datePaidUpper}}"/>
                                </div>
                            </div>
                        }
                        @case (accountStatus.id) {
                            <div class="tabcontent">
                                <p-select (onChange)="setStatus($event.value)"
                                          [options]="statusOptions"
                                          class="form-control"
                                          formControlName="displayStatus"
                                          id="status"
                                          optionLabel="label"
                                          optionValue="value"></p-select>
                            </div>
                        }
                        @case (ecommerceStore.id) {
                            <div class="tabcontent">
                                <select (change)="setEcommerceStoreIds($event)"
                                        class="form-control"
                                        formControlName="ecommerceStoreIds"
                                        id="ecommerceStoreIds">
                                    <option value="">All Shops</option>
                                    @for (storeOption of ecommerceStoreOptions; track storeOption.value) {
                                        <option [value]="storeOption.value">{{ storeOption.label }}</option>
                                    }
                                </select>
                            </div>
                        }
                        @case (batch.id) {
                            <div [hidden]="!showBatchFilter" class="tabcontent">
                                <div class="form-control">
                                    <input (change)="setSearchCriteria($event)"
                                           formControlName="batchSearch"
                                           id="allAccounts"
                                           name="batchSearch"
                                           type="radio"
                                           value="all"> <label>&nbsp;All</label>
                                </div>
                                <div class="form-control">
                                    <input (change)="setSearchCriteria($event)"
                                           formControlName="batchSearch"
                                           id="individualAccounts"
                                           name="batchSearch"
                                           type="radio"
                                           value="individual"> <label>&nbsp;Individual</label>
                                </div>
                                <div class="form-control">
                                    <input #batchAccounts
                                           (change)="setSearchCriteria($event)"
                                           formControlName="batchSearch"
                                           id="batchAccounts"
                                           name="batchSearch"
                                           type="radio"
                                           value="batch"> <label>&nbsp;Batch</label> &nbsp;
                                </div>
                                @if (batchAccounts.checked) {
                                    <input (input)="setSearchCriteria($event)"
                                           class="form-control"
                                           formControlName="batchNumber"
                                           id="batchNumber"
                                           placeholder="Batch Number"
                                           type="text"
                                           value="{{batchNumber}}"/>
                                }
                            </div>
                        }
                        @case (csvExport.id) {
                            <div class="tabcontent">
                                <select (change)="onCsvPeriodChange($event)"
                                        class="form-control"
                                        id="csvExportPeriod">
                                    @for (periodOption of csvPeriodOptions; track periodOption.value) {
                                        <option [value]="periodOption.value"
                                                [selected]="periodOption.value === csvSelectedPeriod">
                                            {{ periodOption.label }}
                                        </option>
                                    }
                                </select>
                                <button (click)="csvDownload.emit()"
                                        [disabled]="csvDownloading"
                                        class="navy-btn btn-margin-top-bottom-10 csv-download-btn"
                                        type="button">
                                    <i class="fa fa-download"></i> Download CSV
                                </button>
                            </div>
                        }
                    }
                </div>
                <div class="row">
                    <div [hidden]="!tabActive || activeTab === csvExport.id" class="col-md-12 text-center">
                        <button (click)="clear(activeTab)"
                                [disabled]="disableClear(activeTab)"
                                class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                                type="button">
                            Clear
                        </button>
                        <button (click)="clearAll()"
                                [disabled]="disableClearAll()"
                                class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                                type="button">
                            Clear All
                        </button>
                        <button (click)="search()"
                                class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
                                type="submit">
                            Update
                        </button>
                    </div>
                </div>
            </form>
        </li>
    </ul>
</div>